import { Button, DialogContent } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  flex-direction: column;
  max-width: 370px;

  .message {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.05em;
    color: ${colors.black};

    a {
      margin-top: 5px;
      color: ${colors.blue};
    }

    span {
      color: ${colors.red05};
      font-size: 15px;
      margin-top: 10px;
      margin-bottom: 15px;
    }
  }
`;

export const Content = lib.styled(DialogContent)`
  &.MuiDialogContent-root {
    padding: 0px 24px;
  }
`;

export const Icon = lib.styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  margin: 20px 0 20px 0;
  width: 70px;
  height: 70px;
  background-color: ${colors.lightBlue};
  border-radius: 50px;
  color: ${colors.white};

  .icon {
    font-size: 32px;
  }
`;

export const Btn = lib.styled(Button)`
  &.MuiButton-textPrimary {
    color: ${colors.lightBlue};
  }
`;
